import { z } from "zod";

export const voiceGuesserCandidateSchema = z.object({
	user_id: z.string(),
	display_name: z.string(),
	avatar_url: z.string().nullable(),
});

export type VoiceGuesserCandidate = z.infer<typeof voiceGuesserCandidateSchema>;
